import qs from 'qs';

import { constitutionApiUrl } from '../../globals';

export const constitutionResponse = {
  ALREADY_VOTED: 'ALREADY_VOTED',
  INVALID_TOKEN: 'INVALID_TOKEN',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
  THANKYOU: 'THANKYOU',
};

export const handleToken = (status) => {
  const parsedToken = qs.parse(window.location.search, { ignoreQueryPrefix: true }).token;
  if (parsedToken && (status === constitutionResponse.SUCCESS
    || status === constitutionResponse.ALREADY_VOTED)) {
    const oldTokens = localStorage.getItem('old-token') || '';
    const token = localStorage.getItem('token') || '';
    localStorage.setItem(
      'old-token',
      oldTokens ? `${oldTokens},${token}` : token,
    );
    localStorage.setItem('token', parsedToken);
  }
};

function buildHeaders(initialToken, contentType) {
  const oldTokens = localStorage.getItem('old-token');
  const token = initialToken || qs.parse(window.location.search, { ignoreQueryPrefix: true }).token || localStorage.getItem('token');

  const headers = {
    'x-token': token,
    'Content-Type': contentType || 'application/json',
  };
  if (oldTokens) headers['x-old-tokens'] = oldTokens;

  return headers;
}

function handlePostStatus(status) {
  if (status === 204 || status === 200) {
    return constitutionResponse.SUCCESS;
  } if (status === 401) {
    return constitutionResponse.INVALID_TOKEN;
  } if (status === 409) {
    return constitutionResponse.ALREADY_VOTED;
  }

  return constitutionResponse.ERROR;
}

function handleGetStatus(status) {
  if (status === 204) {
    return constitutionResponse.SUCCESS;
  } if (status === 401) {
    return constitutionResponse.INVALID_TOKEN;
  } if (status === 200) {
    return constitutionResponse.ALREADY_VOTED;
  }

  return constitutionResponse.ERROR;
}

export const ConstitutionVoteApi = {
  checkToken: async (token) => {
    let resultStatus;
    try {
      const result = await fetch(`${constitutionApiUrl}/consitutionpoll`, {
        method: 'get',
        headers: buildHeaders(token),
      });

      resultStatus = handleGetStatus(result.status);
    } catch (e) {
      // do nothing
    }
    return resultStatus;
  },
  postConstitutionPoll: async (data, token) => {
    let resultStatus;
    try {
      const result = await fetch(`${constitutionApiUrl}/consitutionpoll`, {
        method: 'post',
        headers: buildHeaders(token),
        body: JSON.stringify(data),
      });

      resultStatus = handlePostStatus(result.status);
    } catch (e) {
      // do nothing
    }
    return resultStatus;
  },
  putUserProfile: async (data, token) => {
    let resultStatus;
    try {
      const result = await fetch(`${constitutionApiUrl}/profile`, {
        method: 'put',
        headers: buildHeaders(token),
        body: JSON.stringify(data),
      });

      resultStatus = handlePostStatus(result.status);
    } catch (e) {
      // do nothing
    }
    return resultStatus;
  },
  getUserResults: async () => {
    let tokenStatus;
    let userData;

    try {
      await fetch(`${constitutionApiUrl}/consitutionpoll`, {
        method: 'get',
        headers: buildHeaders(),
      }).then((response) => {
        tokenStatus = handleGetStatus(response.status);
        return response.json();
      }).then((response) => {
        userData = response;
      });
    } catch (e) {
      // do nothing
    }
    return {
      tokenStatus,
      data: userData,
    };
  },
  getEmailLink: async (body) => {
    const response = await fetch(`${constitutionApiUrl}/constitutionemail/getlink`, {
      method: 'post',
      headers: buildHeaders(),
      body: JSON.stringify(body),
    });

    if (response.status === 200 || response.status === 302) {
      return response.url;
    }

    throw new Error('Something went wrong!');
  },
  getEmailFileKey: async (body) => fetch(`${constitutionApiUrl}/constitutionemail/filekey`, {
    method: 'post',
    headers: buildHeaders('text/plain'),
    body: JSON.stringify(body),
  })
    .then((res) => res.text())
    .then((text) => text),
  getHtml: async (data) => fetch(`${constitutionApiUrl}/constitutionemail?data=${data}`, {
    method: 'get',
    headers: buildHeaders('text/html'),
  })
    .then((res) => res.text())
    .then((text) => text),
};
